import { render, staticRenderFns } from "./liveTheClassList.vue?vue&type=template&id=fc945a30&scoped=true"
import script from "./liveTheClassList.vue?vue&type=script&lang=js"
export * from "./liveTheClassList.vue?vue&type=script&lang=js"
import style0 from "./liveTheClassList.vue?vue&type=style&index=0&id=fc945a30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc945a30",
  null
  
)

export default component.exports